import React, { useEffect } from "react";
import HeaderComponent from "../../Pages/Header/Header";
import contact_img from "../../images/contact-us-img.png";
import "./contact.css";
import FooterComponent from "../../Pages/Footer/Footer";
function ContactPageComponent() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top
  }, []);
  return (
    <>
      <HeaderComponent />
      <div className="contact-us-page-section text-center container">
        <h1 className="mt-4 mb-4">We're Here To Help!</h1>
        <div className="contact-content">
          <div className="contact-image">
            <img src={contact_img} alt="contact-image"></img>
          </div>
          <div className="contact-info-para mt-4 mb-5">
            <p className="m-0 mb-5">
              At HOA Verified, we are here to assist you with all your
              Homeowners' Association needs. Whether you have questions about
              compliance, need help navigating our platform, or require support
              with any other aspect of our services, our dedicated team is ready
              to help. Please don't hesitate to reach out to us via phone,
              email, or the contact form below. Your satisfaction is our top
              priority, and we look forward to serving you
            </p>
            <p>
              <span>Need help getting started?</span> Our User Guide will walk
              you through setting up your account.{" "}
              <a href="#">
                Access it here{" "}
                <i className="fa fa-angle-right" aria-hidden="true"></i>
                <i className="fa fa-angle-right" aria-hidden="true"></i>
              </a>
            </p>
          </div>
          <div className="contact-us-block-form text-start">
            <h1 className="mb-5 text-center">Contact Us</h1>
            <div className="form-block">
              <form>
                <div className="form-group mb-3">
                  <label htmlFor="name" className="mb-1">
                    Name*
                  </label>
                  <br></br>
                  <input type="text" id="name" name="name" />
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="community" className="mb-1">
                    Email
                  </label>
                  <br></br>
                  <input type="email" id="email" name="email" />
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="telephone" className="mb-1">
                    Telephone
                  </label>
                  <br></br>
                  <input type="tel" id="telephone" name="telephone" />
                </div>
                <div className="text-center">
                  <button type="submit" className="btn-orange">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <FooterComponent />
    </>
  );
}

export default ContactPageComponent;
